import { Routes } from '@angular/router';
import { LoggedInGuard } from '../shared/guards/loggedin.guard';
import { SuperAdminGuard } from '../shared/guards/super-admin-guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    data: { title: 'general.navigation.home' },
    canActivate: [LoggedInGuard],
    canLoad: [],
  },
  {
    path: 'administration',
    loadChildren: () =>
      import('../administration/administration.module').then(
        (m) => m.AdministrationModule
      ),
    data: { title: 'general.navigation.administration' },
    canActivate: [LoggedInGuard, SuperAdminGuard], //TODO: admin guard
    canLoad: [],
  },
  {
    path: 'project/:id',
    loadChildren: () =>
      import('../project/project.module').then(
        (m) => m.ProjectModule
      ),
    data: { title: 'general.navigation.project' },
    canActivate: [LoggedInGuard],
    canLoad: [],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
